import { apiClient } from './api-client';

export interface WarrantyType {
  id: string;
  tenantId: string;
  code: string;
  name: string;
  description: string | null;
  coverageDetails: string | null;
  isActive: boolean;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface WarrantyTypeListResponse {
  items: WarrantyType[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreateWarrantyTypePayload {
  code: string;
  name: string;
  description?: string;
  coverageDetails?: string;
}

export type UpdateWarrantyTypePayload = Partial<CreateWarrantyTypePayload> & { isActive?: boolean };

export const warrantyTypeService = {
  list: (params: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<WarrantyTypeListResponse> =>
    apiClient.get<WarrantyTypeListResponse>('/warranty-types', { params }).then((r) => r.data),

  listAll: (): Promise<WarrantyType[]> =>
    apiClient
      .get<WarrantyTypeListResponse>('/warranty-types', { params: { pageSize: 100 } })
      .then((r) => r.data.items),

  create: (payload: CreateWarrantyTypePayload): Promise<WarrantyType> =>
    apiClient.post<WarrantyType>('/warranty-types', payload).then((r) => r.data),

  update: (id: string, payload: UpdateWarrantyTypePayload): Promise<WarrantyType> =>
    apiClient.patch<WarrantyType>(`/warranty-types/${id}`, payload).then((r) => r.data),

  remove: (id: string): Promise<void> =>
    apiClient.delete(`/warranty-types/${id}`).then(() => undefined),
};
